duracion_min: 45
faseProduccion: 0
id: 4
preguntas: 5
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Después de firmar
